
define('text!modules/targeting/digital/templates/bin_group_item.html',[],function () { return '<div class="digital type">\n    <div  class="item-c text">{{{name}}}</div>\n</div>\n';});

